import styled from "styled-components";

const PMS = () => {
	return (
		<PMSWrapper>
			<div>Hello From PMS Page</div>
		</PMSWrapper>
	);
};

export default PMS;

const PMSWrapper = styled.div`
	min-height: 500px;
`;
